var _excluded = ["type"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint import/no-named-default: 0 */

import merge from 'lodash/merge';
import { v4 as uuid } from 'uuid';
import { default as actorBuilder, defaultValue as actorDefaultValue } from './actor';
import { default as deviceBuilder, defaultValue as deviceDefaultValue } from './device';
import { default as experimentsBuilder, defaultValue as experimentsDefaultValue } from './experiments';
import { default as experimentMetadataBuilder, defaultValue as experimentMetadataDefaultValue } from './experimentMetadata';
import { default as locationBuilder, defaultValue as locationDefaultValue } from './location';
import { default as objectBuilder, defaultValue as objectDefaultValue } from './objects';
import { default as originBuilder, defaultValue as originDefaultValue } from './origin';
import { default as trackerBuilder, defaultValue as trackerDefaultValue } from './tracker';
import { default as providerBuilder, defaultValue as providerDefaultValue } from './provider';
import { dateTime } from './utils';

/** */

/**
 * Default values:
 *
 * `type`: 'View'
 */

/** */

function routableEventDefaults(eventInput) {
  return merge({
    actor: actorDefaultValue(),
    provider: providerDefaultValue()
  }, eventInput);
}

/**
 * Implements https://github.mpi-internal.com/spt-dataanalytics/event-formats/blob/master/schema/master/events/base-routable-event.json
 */
export function routableEvent(eventInput) {
  return _objectSpread(_objectSpread({}, eventInput), {}, {
    '@id': uuid(),
    creationDate: dateTime(),
    schema: (eventInput || {}).schema || 'http://schema.adevinta.com/events/base-routable-event.json/128.json#',
    provider: providerBuilder(eventInput),
    actor: actorBuilder(eventInput)
  });
}
routableEvent.defaults = routableEventDefaults;

/**
 * Add default value to TrackerEventInput.
 */
function trackerEventInput(eventInput) {
  return merge({
    actor: actorDefaultValue(),
    experiments: experimentsDefaultValue(),
    experimentMetadata: experimentMetadataDefaultValue(),
    device: deviceDefaultValue(),
    location: locationDefaultValue(),
    object: objectDefaultValue(),
    origin: originDefaultValue(),
    provider: providerDefaultValue(),
    tracker: trackerDefaultValue()
  }, eventInput);
}

/**
 * Implements https://github.mpi-internal.com/spt-dataanalytics/event-formats/blob/master/schema/master/events/tracker-event.json
 */
export function trackerEvent(eventInput, sdkConfig) {
  var _ref = eventInput || {},
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'View' : _ref$type,
    props = _objectWithoutProperties(_ref, _excluded);
  var input = trackerEventInput(eventInput);
  var _ref2 = sdkConfig || {},
    pageViewId = _ref2.pageViewId;
  return _objectSpread(_objectSpread({}, props), {}, {
    '@id': uuid(),
    '@type': type,
    pageViewId: pageViewId,
    creationDate: dateTime(),
    schema: (eventInput || {}).schema || 'http://schema.adevinta.com/events/tracker-event.json/226.json',
    actor: actorBuilder(input),
    experiments: experimentsBuilder(input),
    experimentMetadata: experimentMetadataBuilder(input),
    device: deviceBuilder(input),
    location: locationBuilder(input),
    object: objectBuilder(input),
    origin: originBuilder(input),
    provider: providerBuilder(input),
    target: input.target && objectBuilder(_objectSpread(_objectSpread({}, input), {}, {
      object: input.target
    })),
    tracker: trackerBuilder(input)
  });
}
trackerEvent.defaults = trackerEventInput;
export function engagementEvent(eventInput, sdkConfig) {
  return Object.assign(trackerEvent(eventInput, sdkConfig), {
    schema: (eventInput || {}).schema || 'http://schema.adevinta.com/events/engagement-event.json/252.json',
    '@type': 'Engagement'
  });
}
engagementEvent.defaults = trackerEventInput;
export function identity(eventInput) {
  return eventInput;
}
identity.defaults = function () {
  return {};
};